export default {
  error: null,
  isLoggedIn: false,
  isFullyLoggedIn: false,
  user: { initial: true },
  isPasswordSet: false,
  shouldPasswordBeSet: true,
  redirectUrl: '/',
  expenses: {},
  accounts: {},
  months: {},
  years: {}
};



// WEBPACK FOOTER //
// ./src/initialState.ts